import KeenSlider from 'keen-slider';

//Init carousel slider script
window.addEventListener('DOMContentLoaded', () => {
    dynamicSlider = new KeenSlider('#theme-dynamic-carousel', {
        selector: '.theme-dynamic-carousel__content__item',
        controls: true,
        loop: false,
        initial: 0,
    });

    const carouselContent = document.querySelectorAll('.theme-dynamic-carousel__content');
    const carouselItem = document.querySelectorAll('.theme-dynamic-carousel__content__item');
    const dots = createDiv('theme-dynamic-carousel_content__item--dots');

    function createDiv(className) {
        var div = document.createElement("div")
        var classNames = className.split(" ")
        classNames.forEach((name) => div.classList.add(name))
        return div
    }

    dynamicSlider.on('slideChanged', (e) => {
        const itemActive = e.track.details.abs;
        const dotActive = document.querySelectorAll('.dot')
        dotActive.forEach(active => {
            active.classList.remove('active')
        });
        dotActive[itemActive].classList.toggle('active')
    })

    function creatDots() {
        carouselItem.forEach((slider, idx) => {
            const dot = createDiv("dot");
            if (idx === 0){
                dot.classList.add('active')
            }
            dot.addEventListener('click', () => {
                const dotActive = document.querySelectorAll('.dot.active')
                dynamicSlider.moveToIdx(idx)
                dotActive.forEach(active => {
                    active.classList.remove('active')
                });
                dot.classList.toggle('active');
            });
            dots.appendChild(dot);
        })
        carouselContent[0].insertAdjacentElement('afterend', dots);
    }

    creatDots();
})
